import config from '@/config'
import axios from 'axios'

const instance = axios.create({
  baseURL: `${config.getConfig('serverUrl')}`,
  timeout: 30000
})

export const omiseApi = {
  getOmiseConfig: ({ page_id, page_token }) => {
    return instance.get(`/api/omise/config/${page_id}`, {
      headers: {
        AUTHORIZATION: `Bearer ${page_token}`
      }
    })
  },
  postOmiseCreateCharge: ({ data, page_token }) => {
    return instance.post(`/api/omise/create-charge`, data, {
      headers: {
        AUTHORIZATION: `Bearer ${page_token}`
      }
    })
  },
  getOmisePaymentStatus: ({ page_id, page_token, order_id }) => {
    return instance.get(`/api/omise/payment-status/${page_id}/${order_id}`, {
      headers: {
        AUTHORIZATION: `Bearer ${page_token}`
      }
    })
  }
}
